import PresenceAPI from "../api/presence";
import Vue from 'vue'

export const presences = {
    state: {
        presences: [],
        presenceOptions:{
            lineCount:1,
            orderBy:'children.surname',
            orderDirection:'asc',
            selectedYear:0,
            selectedCourse:0,
            selectedDay:'',
            selectedChild:undefined,
            showError:false,
        },
        presencesLoadStatus: 0,
        presenceAddStatus: 0,
        presenceAddText: "",

        presenceEdit: {
            presences:{
                id: 0,
                lp: 0,
                day: '',
                child_id:0,
                entry:null,
                leave:null,
                leaveOrig:null,
                presentOrig:null,
                present:true,
                breakfast:true,
                lunch:true,
                tea:true,
                note:'',
                noteText:undefined,
                deleteNext:false,
                owners:[]
            }
        },
        presenceEditDefault: {
            presences:{
                id: 0,
                lp: 0,
                day: '',
                child_id:0,
                entry:null,
                leave:null,
                leaveOrig:null,
                presentOrig:null,
                present:true,
                breakfast:true,
                lunch:true,
                tea:true,
                note:'',
                noteText:undefined,
                deleteNext:false,
                owners:[]
            }
        },
        presenceEditLoadStatus: 0,
        presenceEditStatus: 0,
        presenceEditText: "",

        presenceDeleteStatus: 0,
        presenceDeleteText: "",

        presenceOfflineMode:false,
        presenceOffline:[],

        presenceKitchenSummaryLoadStatus: 0,
        presenceKitchenSummary:[]

    },

    actions: {
        loadPresences({ state, commit, dispatch }) {
            commit("setPresencesLoadStatus", 1);
                PresenceAPI.getPresences({
                    orderBy:state.presenceOptions.orderBy,
                    orderDirection:state.presenceOptions.orderDirection,
                    selectedYear:state.presenceOptions.selectedYear,
                    selectedCourse:state.presenceOptions.selectedCourse,
                    selectedDay:state.presenceOptions.selectedDay,
                    selectedChild:state.presenceOptions.selectedChild,
                    showError:state.presenceOptions.showError
                })
                .then(function(response) {
                    commit("setPresences", response.data);
                    dispatch("applyIndexOnPresences");
                    commit("setPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPresences", []);
                    commit("setPresencesLoadStatus", 3);
                });
         
        },
    
        setPresenceOptions({ state, commit, dispatch },data){
            commit("setPresenceOptions",data.options);
            //if(data.options.selectedCourse>0){
                dispatch("loadPresences");
            //}
        },
        applyIndexOnPresences({ commit, state, dispatch }) {
            let localPresences = state.presences;

            var i = 1;
            localPresences.forEach(presence => {
                if(Vue._.isArray(presence.presences)){
                    presence.presences = presence.presences[0];
                }

                presence.lp = i;
                i++;
            });

            commit("setPresences",localPresences);
        },
        addPresence({ commit, state, dispatch }, data) {
            commit("setPresenceEditStatus", 1);
            commit("setPresenceAddText", "");

            PresenceAPI.postAddNewPresence(
                data.child_id,
                data.day,
                data.entry,
                data.leave,
                data.present,
                data.breakfast,
                data.lunch,
                data.tea,
                data.note,
            )
                .then(function(response) {
                    commit("setPresenceEditStatus", 2);
                    commit("setAddedPresence",response.data);
                    dispatch("applyIndexOnPresences");
                    //dispatch("loadMenuDictionariesCount");
                    //dispatch("loadPresenceLookup",{child_id:response.data.child_id});
                })
                .catch(function(error) {
                    //commit("setPresenceEditStatus", 3);
                    commit("setPresenceAddText", error.response.data.errors);
                });
        },
        addPresenceV2({ commit, state, dispatch }, data) {
            commit("setPresenceEditStatus", 1);
            commit("setPresenceAddText", "");

            PresenceAPI.postAddNewPresenceV2(
                data.child_id,
                data.day,
                data.entry,
                data.leave,
                data.present,
                data.breakfast,
                data.lunch,
                data.tea,
                data.note,
                data.picking_up
            )
                .then(function(response) {
                    commit("setPresenceEditStatus", 2);
                    commit("setAddedPresence",response.data);
                    dispatch("applyIndexOnPresences");
                    //dispatch("loadMenuDictionariesCount");
                    //dispatch("loadPresenceLookup",{child_id:response.data.child_id});
                })
                .catch(function(error) {
                    //commit("setPresenceEditStatus", 3);
                    commit("setPresenceAddText", error.response.data.errors);
                });
        },

        loadPresenceEdit({ commit,state }, data) {
            commit("setPresenceEditLoadStatus", 1);
            commit("setPresenceEditStatus", 0);
            commit("setPresenceEditText", "");

            PresenceAPI.getPresenceEdit(data.slug,state.presenceOptions.selectedDay)
                .then(function(response) {
                    commit("setPresenceEdit", response.data);
                    commit("setPresenceEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPresenceEdit", {});
                    commit("setPresenceEditLoadStatus", 3);
                });
        },
        loadPresenceEditById({ commit,state }, data) {
            commit("setPresenceEditLoadStatus", 1);
            commit("setPresenceEditStatus", 0);
            commit("setPresenceEditText", "");

            PresenceAPI.getPresenceEdit(data.slug,data.selectedDay)
                .then(function(response) {
                    commit("setPresenceEdit", response.data);
                    commit("setPresenceEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPresenceEdit", {});
                    commit("setPresenceEditLoadStatus", 3);
                });
        },
       
        loadPresenceEditDefault({ commit }) {
            commit("setPresenceEditDefault");
        },
        loadPresenceAddDefault({ commit }) {
            commit("setPresenceAddStatus", 0);
            commit("setPresenceAddText", "");
        },
        editPresence({ commit, state, dispatch }, data) {
            commit("setPresenceEditStatus", 1);

            PresenceAPI.putEditPresence(
                data.slug,
                data.child_id,
                data.day,
                data.entry,
                data.leave,
                data.present,
                data.breakfast,
                data.lunch,
                data.tea,
                data.note,
                data.deleteNext
            )
                .then(function(response) {
           
                    commit("setPresenceEditStatus", 2);
                    commit("setEditedPresence",response.data)
                    dispatch("applyIndexOnPresences");
                    //dispatch("loadPresenceLookup",{year_id:response.data.year_id});
                })
                .catch(function(error) {
                    commit("setPresenceEditStatus", 3);
                    commit("setPresenceEditText", error.response.data.errors);
                });
        },
        editPresenceV2({ commit, state, dispatch }, data) {
            commit("setPresenceEditStatus", 1);

            PresenceAPI.putEditPresenceV2(
                data.slug,
                data.child_id,
                data.day,
                data.entry,
                data.leave,
                data.present,
                data.breakfast,
                data.lunch,
                data.tea,
                data.note,
                data.deleteNext,
                data.picking_up
            )
                .then(function(response) {
           
                    commit("setPresenceEditStatus", 2);
                    commit("setEditedPresence",response.data)
                    dispatch("applyIndexOnPresences");
                    //dispatch("loadPresenceLookup",{year_id:response.data.year_id});
                })
                .catch(function(error) {
                    commit("setPresenceEditStatus", 3);
                    commit("setPresenceEditText", error.response.data.errors);
                });
        },
        forceDeletePresence({ commit, state, dispatch }, data) {
            commit("setPresenceDeleteStatus", 1);

            PresenceAPI.forceDeletePresence(data.slug)
                .then(function(response) {
                    commit("setPresenceDeleteStatus", 2);
                    commit("setDeletedPresence",response.data)
                    dispatch("applyIndexOnPresences");
                })
                .catch(function() {
                    commit("setPresenceDeleteStatus", 3);
                });
        },

        addChildAbsense({ commit, state, dispatch }, data) {
            commit("setPresenceAddStatus", 1);

            PresenceAPI.putChildAbsense(
                data.child_id,
                data.note,
                data.noteText,
                data.from,
                data.to,
            )
                .then(function(response) {
                    commit("setPresenceAddStatus", 2);
                })
                .catch(function(error) {
                    commit("setPresenceAddStatus", 3);
                    commit("setPresenceAddText", error.response.data.errors);
                });
        },
        loadPresenceAddDefault({ commit }) {
            commit("setPresenceAddStatus", 0);
            commit("setPresenceAddText", "");
        },
        loadKitchenSummary({ state, commit, dispatch },data) {
            commit("setPresenceKichenSummaryLoadStatus", 1);
            PresenceAPI.getKitchenSummary(data.selectedDay)
                .then(function(response) {
                    commit("setPresenceKichenSummary", response.data);
                    commit("setPresenceKichenSummaryLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPresenceKichenSummary", []);
                    commit("setPresenceKichenSummaryLoadStatus", 3);
                });
         
        },
    },
    mutations: {
        setPresenceOptions(state,options){
            state.presenceOptions = options;
        },
        setPresencesLoadStatus(state, status) {
            state.presencesLoadStatus = status;
        },
        setPresences(state, presences) {
            state.presences = presences;
        },
        setPresenceAddStatus(state, status) {
            state.presenceAddStatus = status;
        },
        setPresenceAddText(state, text) {
            state.presenceAddText = text;
        },
        setPresenceEdit(state, presence) {
            //pobiera dane do edycji
            if(Vue._.isArray(presence.presences) && presence.presences.length>0){//jest obecnosc
                presence.presences = presence.presences[0];
                presence.presences.leaveOrig = presence.presences.leave;
                presence.presences.presentOrig = presence.presences.present;
                presence.presences.deleteNext = false;
            }else{
                presence.presences = JSON.parse(JSON.stringify(state.presenceEditDefault.presences));;
                presence.presences.child_id = presence.id;
                presence.presences.day = state.presenceOptions.selectedDay;
            }

            if(presence.rate && !presence.rate.hasBreakfast)presence.presences.breakfast = false;
            if(presence.rate && !presence.rate.hasLunch)presence.presences.lunch = false;
            if(presence.rate && !presence.rate.hasTea)presence.presences.tea = false;

            state.presenceEdit = presence;
        },
        setEditedPresence(state, presence) {
            var index = Vue._.findIndex(state.presences,{'id':presence.child_id});
            state.presences[index].presences = presence;
        },
        setAddedPresence(state, presence) {
            var index = Vue._.findIndex(state.presences,{'id':presence.child_id});
            state.presences[index].presences = presence;
        },
      
        setDeletedPresence(state, presence) {
            var index = Vue._.findIndex(state.presences,{'id':presence.child_id});
            state.presences[index].presences = [];
            //state.presences.splice(index,1);
        },
        setPresenceEditDefault(state) {
            state.presenceEdit = { ...state.presenceEditDefault };
        },
        setPresenceEditStatus(state, status) {
            state.presenceEditStatus = status;
        },
        setPresenceEditText(state, text) {
            state.presenceEditText = text;
        },
        setPresenceEditLoadStatus(state, status) {
            state.presenceEditLoadStatus = status;
        },
        setPresenceDeleteStatus(state, status) {
            state.presenceDeleteStatus = status;
        },
        setPresenceDeletedText(state, text) {
            state.presenceDeleteText = text;
        },
        setPresenceOffline(state,offline){
            state.presenceOffline = offline;
        },
        setPresenceOfflineMode(state,offlineMode){
            state.presenceOfflineMode = offlineMode;
        },
        setPresenceKichenSummaryLoadStatus(state,status){
            state.presenceKitchenSummaryLoadStatus = status;
        },
        setPresenceKichenSummary(state,presence){
            state.presenceKitchenSummary = presence;
        }
    },

    getters: {
        getPresenceOptions(state){
            return state.presenceOptions;
        },
        getPresencesLoadStatus(state) {
            return function(){
                return state.presencesLoadStatus;
            }
        },
        getPresences(state) {
            return state.presences;
        },
        getPresenceAddStatus(state) {
            //return function(){
                return state.presenceAddStatus;
            //} 
        },
        getPresenceAddText(state) {
            return state.presenceAddText;
        },
        getPresenceEdit(state) {
            return state.presenceEdit;
        },
        getPresenceEditStatus(state) {
          return function(){
            return state.presenceEditStatus;
          }
        },
        getPresenceEditing(state) {
            return state.presenceEdit.presences.id > 0;
        },
        getPresenceEditText(state) {
            return state.presenceEditText;
        },
        getPresenceEditLoadStatus(state) {
            return state.presenceEditLoadStatus;
            
        },
        getPresenceDeleteStatus(state) {
            return function(){
                return state.presenceDeleteStatus;
            }
        },
        getPresenceDeleteText(state) {
            return state.presenceDeleteText;
        },
        getPresenceOffline(state){
            return state.presenceOffline;
        },
        getPresenceOfflineMode(state){
            return state.presenceOfflineMode;
        },
        getPresenceKitchenSummaryLoadStatus(state){
            return state.presenceKitchenSummaryLoadStatus;
        },
        getPresenceKitchenSummary(state){
            return state.presenceKitchenSummary;
        }
    }
};
